import React from 'react';
import { useAppDispatch } from '@/store/hooks';
import {
  useDataPresentationParam,
  useDatasourceId,
  useQueryId,
  useSeriesId,
} from '@/hooks';
import { setLastVisitedURL } from '@/features/query-builder/queryBuilderSlice';

export const useUpdateLastVisitedQueryURL = () => {
  const dispatch = useAppDispatch();
  const datasourceId = useDatasourceId();
  const presentation = useDataPresentationParam();
  const queryId = useQueryId();
  const seriesId = useSeriesId();

  React.useEffect(() => {
    if (queryId) {
      dispatch(
        setLastVisitedURL(
          `/datasources/${datasourceId}/queries/${queryId}${
            presentation ? `/${presentation}` : ''
          }`,
        ),
      );
    }
  }, [queryId, datasourceId, presentation]);

  React.useEffect(() => {
    if (seriesId) {
      dispatch(
        setLastVisitedURL(
          `/datasources/${datasourceId}/saved-queries/${seriesId}${
            presentation ? `/${presentation}` : ''
          }`,
        ),
      );
    }
  }, [seriesId, datasourceId, presentation]);
};
